class AccordionExpandCollapseActions {

	constructor(expandAllButton, expandButtonLabelDefault, expandButtonLabelExpanded, normalExpandCollapseBtns, collapsingElements) {
		this.expandAllButton = expandAllButton;
		this.expandButtonLabelDefault = expandButtonLabelDefault;
		this.expandButtonLabelExpanded = expandButtonLabelExpanded;
		this.normalExpandCollapseBtns = normalExpandCollapseBtns;
		this.collapsingElements = collapsingElements;
	}

	/* Sets the expandAllButton Label */
	setExpandallButtonLabel(setNewLabel) {
		this.expandButtonLabel = setNewLabel;
		return this.expandButtonLabel;
	}

	/* Gets the expandAllButton Label */
	getExpandAllButtonLabel() {
		return this.expandButtonLabel;
	}

	/* Sets aria values for the normal accordion buttons that are contained within each accordion section */
	setEventForNormalAccordionButton(theElement) {
		theElement.addEventListener('click', () => {
			if (theElement.getAttribute('aria-expanded') === 'false') {
				theElement.setAttribute('aria-expanded', 'true');
			} else {
				theElement.setAttribute('aria-expanded', 'false');
			}
		});
	}
	/* Loops through the targeted elements that are to collapse and changes their states using parameters */
	runAriaAndClassSwitchLoop(theNodeArray, theIndex, theClassModifier, theClassState, theAriaState) {
		for (theIndex = 0; theIndex < theNodeArray.length; theIndex += 1) {
			if (theClassModifier === 'add') {
				theNodeArray[theIndex].classList.add(theClassState);
			} else {
				theNodeArray[theIndex].classList.remove(theClassState);
			}
			theNodeArray[theIndex].previousElementSibling.children[0].children[0].setAttribute('aria-expanded', theAriaState);
		}
	}

	/* Sets up the Accordion Expand and Collapse Actions */
	AccordionExpandCollapse() {
		var rpc;
		for (rpc = 0; rpc < this.normalExpandCollapseBtns.length; rpc += 1) {
			this.setEventForNormalAccordionButton(this.normalExpandCollapseBtns[rpc]);
		}

		this.expandAllButton.addEventListener('click', () => {
			this.expandAllButton.classList.toggle('s');

			var xvc;

			if (this.expandAllButton.classList.contains('s')) {

				this.expandAllButton.innerHTML = this.expandButtonLabelExpanded;
				this.runAriaAndClassSwitchLoop(this.collapsingElements, xvc, 'add', 'show', 'true');

			} else {

				this.expandAllButton.innerHTML = this.expandButtonLabelDefault;
				this.runAriaAndClassSwitchLoop(this.collapsingElements, xvc, 'remove', 'show', 'false');

			}
		});
	}


};

export default AccordionExpandCollapseActions;

